/* TWRD 2026-10-21: "KEEP ME UPDATED" drawer for UPCOMING product cards.
   Markup: snippets/twrd-notify-drawer.liquid (a <template>, rendered once per page).
   Trigger: the bell on an upcoming card, [data-twrd-notify] (snippets/product-card.liquid).
   The drawer is the theme's <modal-dialog> (a11y-dialog): overlay, Esc, focus trap.
   The sign-up post is the same as submitSignup() in assets/twrd-quick-add.js.
   That one is private to the quick add sheet, so the logic is mirrored here. */
(function () {
  'use strict';
  if (window.__twrdNotifyInit) return;
  window.__twrdNotifyInit = true;

  var TRIGGER = '[data-twrd-notify]';
  var drawer = null;
  var el = {};
  var current = null;
  var lastBell = null;

  function q(name) {
    return drawer.querySelector('[data-twrd-notify-' + name + ']');
  }

  /* Clone the template into <body> on first use. */
  function mount() {
    if (drawer) return drawer;
    var tpl = document.getElementById('twrd-notify-template');
    if (!tpl || !tpl.content) return null;
    var host = document.getElementById('moved-modal-elements') || document.body;
    host.appendChild(tpl.content.cloneNode(true));
    drawer = document.getElementById('twrd-notify');
    if (!drawer) return null;
    el = {
      img: q('img'),
      name: q('name'),
      colour: q('colour'),
      up: q('up'),
      form: drawer.querySelector('form'),
      tags: q('tags'),
      email: q('email'),
      submit: q('submit'),
      error: q('error'),
      done: q('done')
    };
    el.form.addEventListener('submit', submit);
    drawer.addEventListener('on:modal:closed', function () {
      if (lastBell && document.contains(lastBell)) lastBell.focus({ preventScroll: true });
    });
    return drawer;
  }

  function sized(src, width) {
    if (!src) return '';
    return src.replace(/([?&])width=\d+/, '$1width=' + width);
  }

  function reset() {
    el.up.classList.remove('is-done');
    el.form.reset();
    el.error.hidden = true;
    el.error.textContent = '';
    el.done.hidden = true;
    el.submit.disabled = false;
  }

  function fill(bell) {
    var handle = bell.getAttribute('data-notify-handle') || '';
    var title = bell.getAttribute('data-notify-title') || '';
    var colour = bell.getAttribute('data-notify-colour') || '';
    var image = bell.getAttribute('data-notify-image') || '';
    current = { handle: handle, url: bell.getAttribute('data-notify-url') || '' };
    reset();
    el.name.textContent = title;
    el.colour.textContent = colour;
    el.colour.hidden = !colour;
    if (image) {
      el.img.src = sized(image, 240);
      el.img.srcset = sized(image, 240) + ' 240w, ' + sized(image, 480) + ' 480w';
      el.img.sizes = '120px';
    }
    el.img.alt = title;
    el.tags.value = 'upcoming,upcoming-' + handle;
  }

  function open(bell) {
    if (!mount()) {
      /* No drawer on this page: the PDP has the same sign-up. */
      var url = bell.getAttribute('data-notify-url');
      if (url) window.location.href = url + '#sign-up';
      return;
    }
    lastBell = bell;
    fill(bell);
    customElements.whenDefined('modal-dialog').then(function () {
      /* a11y-dialog returns focus to the active element. Safari does not
         focus a clicked button, so focus the bell first. */
      bell.focus({ preventScroll: true });
      drawer.open().then(function () {
        if (el.email) el.email.focus({ preventScroll: true });
      });
    });
  }

  function error(text) {
    el.error.textContent = text;
    el.error.hidden = false;
    el.submit.disabled = false;
  }

  /* Post the customer form in the background, so the drawer stays open.
     Shopify answers a good post with a redirect to ?customer_posted=true.
     A bot challenge needs the real page, so then the form posts natively. */
  function submit(event) {
    event.preventDefault();
    if (!current) return;
    el.error.hidden = true;
    var email = (el.email.value || '').trim();
    el.email.value = email;
    if (!email || !el.email.checkValidity()) {
      error('Check the email address and try again.');
      el.email.focus({ preventScroll: true });
      return;
    }
    el.tags.value = 'upcoming,upcoming-' + current.handle;
    el.submit.disabled = true;
    fetch(el.form.action, {
      method: 'POST',
      body: new FormData(el.form),
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    })
      .then(function (response) {
        var url = response.url || '';
        if (url.indexOf('/challenge') !== -1) {
          el.form.removeEventListener('submit', submit);
          el.form.submit();
          return;
        }
        if (response.ok && url.indexOf('customer_posted=true') !== -1) {
          el.up.classList.add('is-done');
          el.done.hidden = false;
          el.submit.disabled = false;
          el.done.focus({ preventScroll: true });
          return;
        }
        error('Check the email address and try again.');
      })
      .catch(function (err) {
        error('Could not sign you up. Please try again.');
        if (window.console) console.warn('twrd-notify-drawer: sign-up failed', err);
      });
  }

  /* Delegated: works for cards added later (infinite scroll, recommendations). */
  document.addEventListener('click', function (event) {
    var bell = event.target.closest && event.target.closest(TRIGGER);
    if (!bell) return;
    event.preventDefault();
    event.stopPropagation();
    open(bell);
  }, true);
})();
